import React__default from 'react';
import { marked } from '../../../../../node_modules/marked/lib/marked.esm.mjs';
import { UncustomizableMarkup } from '@vp/swan';

function OptionMarkdownText({ markdownText }) {
    // NOTE - marked.parse returns "string | Promise<string>". It will only ever
    // return a promise if you're using "async: true" and a custom "walkTokens" processor.
    // So... this is a safe cast to "string"
    // https://marked.js.org/using_pro#async
    const markdownHtml = marked.parse(markdownText ?? "", { async: false });
    return (React__default.createElement(React__default.Fragment, null, markdownText && (React__default.createElement(UncustomizableMarkup, { className: "product-options-markdown" },
        React__default.createElement("div", { dangerouslySetInnerHTML: { __html: markdownHtml } })))));
}

export { OptionMarkdownText };
//# sourceMappingURL=option-markdown-text.mjs.map
